import React, { PropTypes } from 'react';
import moment from 'moment';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import AccessibleDatePicker from '@bibliocommons/base-accessibility-date-picker';
import { TextButton } from '@bibliocommons/base-buttons';
import { CalendarEmpty } from '@bibliocommons/base-icons';

import ShortFormattedDate from '../../../shared/ShortFormattedDate';
import ImmutablePropTypes from 'react-immutable-proptypes';

import './HoldsExpiryDate.scss';

export default class HoldsExpiryDate extends BcReactComponent {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      date: this.getExpiryDate()
    };
    this.bindAll('handleDate', 'handleClose');
  }

  getExpiryDate() {
    return this.props.item.get('expiryDate');
  }

  handleDate(date) {
    this.setState({ date });
    this.props.handleUpdateExpiryDate(date);
  }

  handleClose() {
    this.setState({
      open: false
    });
  }

  render() {
    const isExpiryDateEditable = this.props.item.get('actions').includes('updateExpiry');

    return (
      <div className="cp-holds-expiry-date">
        {isExpiryDateEditable ?
          <AccessibleDatePicker
            open={this.state.open}
            onDateChange={this.handleDate}
            handleClose={this.handleClose}
            initialDate={this.getExpiryDate()}
            isOutsideRange={(day) => !day.isAfter(moment(), 'day')}
            fullScreen>
            <TextButton
              disabled={this.props.disabled}
              showLoadingText
              isLoading={this.props.isLoading}
              className="cp-holds-expiry-button"
              handleClick={() => this.setState({ open: true })}>
              <CalendarEmpty />
              <ShortFormattedDate value={this.getExpiryDate()} />
            </TextButton>
          </AccessibleDatePicker> : <ShortFormattedDate value={this.state.date} />
      }
      </div>
    );
  }
}

HoldsExpiryDate.propTypes = {
  item: ImmutablePropTypes.map,
  handleUpdateExpiryDate: PropTypes.func,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsExpiryDate/HoldsExpiryDate.jsx